import MuiInputAdornment from "@mui/material/InputAdornment";
const InputAdornment = MuiInputAdornment;
export default InputAdornment;
